import EventTermsConditionsForm from './EventTermsConditionsForm'

export default EventTermsConditionsForm
